import { createUseAppTranslation } from '@sib/i18n';

export const useTicketsAppTranslation = createUseAppTranslation('tickets');
